import React, { useState, useEffect } from "react";
import Template from "./templateCard";
import axios from "../../../Axios";
import { notification, message } from "antd";
import classes from "./templates.module.css";
const Templates = () => {
  const [templatesData, setTemplates] = useState({});
  useEffect(() => {
    console.log(templatesData);
  }, [templatesData]);
  useEffect(() => {
    const FetchFunc = async () => {
      const fetchData = await axios.post("/templates/fetch", {
        fetchType: 0,
        fetchItems: ["title"],
      });
      const { payload } = fetchData.data;
      const tempTemplates = {};

      payload.map((template) => {
        return (tempTemplates[template["_id"]] = {
          title: template.title,
        });
      });

      setTemplates(tempTemplates);
    };
    FetchFunc();
  }, []);

  const deleteHandler = async (id) => {
    try {
      const disable = await axios.post("/templates/delete", {
        where: { _id: id },
      });
      const tempTemplates = { ...templatesData };
      delete tempTemplates[id];
      message.success("Deleted Successfully");
      setTemplates(tempTemplates);
    } catch (err) {
      const openNotificationWithIcon = (type, message, description) => {
        notification[type]({
          message: `${message}`,
          description: `${description}`,
        });
      };
    }
  };
  const templates = Object.keys(templatesData).map((cur) => (
    <Template
      onDelete={() => deleteHandler(cur)}
      id={cur}
      key={cur}
      title={templatesData[cur].title}
    />
  ));

  return (
    <div>
      <div>
        <h2>Templates</h2>
        <hr />
      </div>
      <div>
        <div className={classes.txt}>
          <p>
            {" "}
            Pre-template of Audits <br />
            Presets can be modified and edited
          </p>
        </div>
        <div className={classes.template}>{templates}</div>
      </div>
      <div className={classes.mt}>
        <h1>Customizable Templates</h1>
        <hr />
      </div>
      <div className={classes.template}>{templates}</div>
    </div>
  );
};

export default Templates;
